/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import { createGlobalStyle } from "styled-components"

import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"

import '../utils/typography.js'

import theme from '../theme/theme'

const GlobalStyle = createGlobalStyle`
  html, body {
    background-color: #070509;
    height:100%;
    width:100%;
  }
  body {
    overflow: hidden;
    color: ${props => (props.whiteColor ? 'white' : 'black')};
  }
  h1, h2, h3, h4 {
    color: ${theme.primaryColor};
  }
`

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <React.Fragment>
        <GlobalStyle whiteColor />
          <div>{children}</div>
      </React.Fragment>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
